import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: (p) => p.spacing(1),
};

export const container: SxStyle = {
  width: '100%',
};
